import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "@shared/services/toaster.service";
import { FE_TermsEditable } from "@shared/models/terms";
import { AdminTermsApiService } from "@shared/services/admin/admin-terms-api.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { SpinnerComponent } from "../../elements/spinner/spinner.component";
import { IboxComponent } from "../../elements/ibox/ibox.component";
import { LogService } from "@shared/services/log.service";


@Component({
    templateUrl: "./terms.component.html",
    styleUrls: ["./terms.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, IboxComponent, RouterLink, TranslatePipe]
})
export class AdminTermsComponent implements OnInit {

    // TODO: "New draft" per policy button
    // TODO: Delete button

    public isLoading = true;
    public policies: FE_TermsEditable[];

    constructor(
        private readonly adminTerms: AdminTermsApiService,
        private readonly toaster: ToasterService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        public translate: TranslateService,
        private readonly logService: LogService,
    ) {
        this.translate = translate;
    }

    public ngOnInit() {
        this.adminTerms.getAllPolicies().then(policies => {
            this.policies = [
                ...policies.filter(p => p.version === "draft"),
                ...policies.filter(p => p.version !== "draft"),
            ];
            this.isLoading = false;
        }).catch(err => {
            this.logService.error(err);
            this.translate.get('Failed to load policies').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }

    public createPolicy() {
        this.router.navigate(["new"], {relativeTo: this.activatedRoute});
    }

}
